import { render, staticRenderFns } from "./User.vue?vue&type=template&id=0dca611c&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dca611c')) {
      api.createRecord('0dca611c', component.options)
    } else {
      api.reload('0dca611c', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=0dca611c&", function () {
      api.rerender('0dca611c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/Crud/User.vue"
export default component.exports